<ng-container *ngIf="hasEnoughImages; else singleImage">
  <div
    class="d-flex flex-row justify-content-around usb-media-banner__grid"
    [style.height.px]="height"
    [style.margin]="wrapperMargin"
    style="gap: 0.25em"
  >
    <!-- Hero (large) -->
    <media-slot
      style="width: 70%;"
      *ngIf="showPlaceholders && !hasAnyImage; else heroImage"
      mode="placeholder"
      size="large"
      [customHeight]="height"
      ariaLabel="Sin imagen disponible">
    </media-slot>
    <ng-template #heroImage>
      <media-slot
        style="width: 70%;"
        mode="image"
        size="large"
        [src]="images[0]?.thumbnail"
        [customHeight]="height"
        ariaLabel="Ver imagen en grande"
        (open)="openImage.emit(0)">
      </media-slot>
    </ng-template>

    <!-- Right column with two small slots -->
    <div class="d-flex flex-column" style="height: auto; width: 34%">
      <!-- Slot index 1 -->
      <media-slot
        *ngIf="showPlaceholders && !hasAnyImage; else slot1Image"
        mode="placeholder"
        size="small"
        [customHeight]="sideImageHeight"
        ariaLabel="Sin imagen disponible">
      </media-slot>
      <ng-template #slot1Image>
        <media-slot
          *ngIf="images[1]?.thumbnail as src1"
          mode="image"
          size="small"
          [src]="src1"
          [customHeight]="sideImageHeight"
          ariaLabel="Ver imagen en grande"
          (open)="openImage.emit(1)">
        </media-slot>
      </ng-template>

      <!-- Slot index 2 (with active media + buttons overlay) -->
      <div class="w-100 h-50 mt-1" style="position: relative">
        <media-slot
          *ngIf="activeMedia?.type === 'image'"
          mode="image"
          size="small"
          [src]="activeMedia.src"
          [customHeight]="sideImageHeight"
          ariaLabel="Ver imagen en grande"
          (open)="openImage.emit(activeMediaIndex)">
        </media-slot>
        <media-slot
          *ngIf="activeMedia?.type === 'video'"
          mode="video"
          size="small"
          [customHeight]="sideImageHeight"
          ariaLabel="Reproducir video"
          (open)="openVideo.emit(activeMediaIndex)">
        </media-slot>
        <media-slot
          *ngIf="!activeMedia && images[2]?.thumbnail as src2"
          mode="image"
          size="small"
          [src]="src2"
          [customHeight]="sideImageHeight"
          ariaLabel="Ver imagen en grande"
          (open)="openImage.emit(2)">
        </media-slot>
        <media-slot
          *ngIf="!activeMedia && !images[2]?.thumbnail && videos.length > 0"
          mode="video"
          size="small"
          [customHeight]="sideImageHeight"
          ariaLabel="Abrir video"
          (open)="openVideo.emit(0)">
        </media-slot>
        <media-slot
          *ngIf="!activeMedia && !images[2]?.thumbnail && showPlaceholders && videos.length === 0"
          mode="placeholder"
          size="small"
          [customHeight]="sideImageHeight"
          ariaLabel="Sin imagen disponible">
        </media-slot>

        <!-- Buttons row (media selector + "+ de N fotos") -->
        <div
          *ngIf="mediaItems.length > 0"
          class="d-flex align-items-center justify-content-center usb-media-banner__selector"
          style="
            background-color: #ececec;
            position: absolute;
            bottom: 1em;
            right: 2em;
            border-radius: 20px;
            border: none;
            padding: 4px 3px;
            padding-right: 8px;
            gap: 3px;
          "
        >
          <ng-container *ngFor="let media of mediaItems; let mi = index">
            <button
              class="usb-modal-experience-btn-icon"
              [class.usb-modal-experience-btn-icon-active]="activeMediaIndex === mi"
              (click)="media.type === 'video' ? openVideoMedia.emit(mi) : selectMedia.emit({ index: mi, disabled: media.disabled })"
              type="button"
              [disabled]="media.disabled"
            >
              <img
                width="20"
                height="20"
                [src]="media.type === 'video'
                  ? '../../../../assets/icons/itinerary/video_inst.svg'
                  : '../../../../assets/icons/modals/modal-tours/video-01.svg'"
                [alt]="media.type"
              />
            </button>
          </ng-container>
          <p class="mb-0 usb-modal-experience-text extra-small bold">
            {{ mediaItemsLabel }}
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #singleImage>
  <div
    class="usb-media-banner__single"
    [style.height.px]="height"
    [style.margin]="wrapperMargin"
    style="position: relative"
  >
    <media-slot
      *ngIf="hasAnyImage; else fallbackPlaceholder"
      style="width: 100%"
      mode="image"
      size="large"
      [src]="images[0]?.thumbnail"
      [customHeight]="height"
      ariaLabel="Ver imagen en grande"
      (open)="openImage.emit(0)">
    </media-slot>
    <ng-template #fallbackPlaceholder>
      <media-slot
        *ngIf="showPlaceholders"
        style="width: 100%"
        mode="placeholder"
        size="large"
        [customHeight]="height"
        ariaLabel="Sin imagen disponible">
      </media-slot>
    </ng-template>

    <!--
      Cuando hay menos de 3 imágenes pero sí hay videos, el banner cae al path
      `singleImage` (imagen full-width sin slot chico). El selector de mediaItems
      que normalmente vive en el slot 2 queda huérfano, así que lo reubicamos
      acá, flotando abajo a la derecha.
    -->
    <div
      *ngIf="mediaItems.length > 0"
      class="d-flex align-items-center justify-content-center usb-media-banner__selector"
      style="
        background-color: #ececec;
        position: absolute;
        bottom: 1em;
        right: 1em;
        border-radius: 20px;
        border: none;
        padding: 4px 8px;
        gap: 3px;
      "
    >
      <ng-container *ngFor="let media of mediaItems; let mi = index">
        <button
          class="usb-modal-experience-btn-icon"
          [class.usb-modal-experience-btn-icon-active]="activeMediaIndex === mi"
          (click)="media.type === 'video' ? openVideoMedia.emit(mi) : selectMedia.emit({ index: mi, disabled: media.disabled })"
          type="button"
          [disabled]="media.disabled"
        >
          <img
            width="20"
            height="20"
            [src]="media.type === 'video'
              ? '../../../../assets/icons/itinerary/video_inst.svg'
              : '../../../../assets/icons/modals/modal-tours/video-01.svg'"
            [alt]="media.type"
          />
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>